<template>
  <div class="demo-collapse">
    <el-collapse v-model="activeName" accordion>
    <!-- <draggable
      :list="groupsData.children"
      :element="'el-collapse'"
      draggable=".handle"
      @end="onEnd($event)"
    > -->
      <span class="handle">
        <template v-if="groupsData.children && groupsData.children.length">
          <!-- <template v-for="child in groupsData.children"> -->
          <div class="pull-right disable-chck-location-groups">
            <div class="col-md-6">
              <p-checkbox
                v-model="groupsData.active"
                :key="groupsData.name + '_' + groupsData.id"
                @input="handleActiveGroup(groupsData)" 
              >{{$t('settingsOrdering.enabled')}}</p-checkbox>
            </div>
            <div class="col-md-1 mar-lt-15">
              <!-- <i class="fa fa-pencil" @click="openEditLocationGroupModal(groupsData)"></i> -->
              <a
                class="btn btn-icon btn-info mar-rt-10"
                style="top: -5px;"
                :title="$t('general.edit')" 
                @click="openEditLocationGroupModal(groupsData)">
                <i class="ti-pencil"></i>
              </a>
            </div>
          </div>
          <el-collapse-item :title="groupsData.name" :name="groupsData.name + '_' + groupsData.id">
            <template v-if="groupsData.children.length">
              <template v-for="newphew in groupsData.children">
                <location-group-section 
                  :name="newphew.name + '_' + newphew.id"
                  :groupsDataProp="newphew"
                  :groupToBeDeletedProp="groupToBeDeleted"
                  :groupToBeAddedProp="groupToBeAdded"
                  :groupToBeEditedProp="groupToBeEdited"
                  @open-modal="openEditLocationGroupModal($event)"
                ></location-group-section>
              </template>
            </template>
            <template v-else>
              <div class="pull-left status-line pad-to-10 order-buttons resize-method overflow-container">
                <template v-for="(loc, id) in groupsData.location_ids">
                  <button class="btn btn-status-margin tablet-overflow ">
                    {{loc.name}}
                  </button>
                </template> 
              </div>
            </template>
          </el-collapse-item>
          <!-- </template> -->
        </template>
        <template v-else>
          <div class="pull-right disable-chck-location-groups">
            <div class="col-md-6">
              <p-checkbox
                v-model="groupsData.active"
                :key="groupsData.name + '_' + groupsData.id"
                @input="handleActiveGroup(groupsData)" 
              >{{$t('settingsOrdering.enabled')}}</p-checkbox>
            </div>
            <div class="col-md-1 mar-lt-15">
              <!-- <i class="fa fa-pencil" @click="openEditLocationGroupModal(groupsData)"></i> -->
              <a
                class="btn btn-icon btn-info mar-rt-10"
                style="top: -5px;"
                :title="$t('general.edit')" 
                @click="openEditLocationGroupModal(groupsData)">
                <i class="ti-pencil"></i>
              </a>
            </div>
          </div>
          <el-collapse-item :title="groupsData.name" :name="groupsData.name + '_' + groupsData.id">
            <div class="pull-left status-line pad-to-10 order-buttons resize-method overflow-container">
              <template v-for="(loc, id) in groupsData.location_ids">
                <button class="btn btn-status-margin tablet-overflow ">
                  {{loc.name}}
                </button>
              </template> 
            </div>
          </el-collapse-item>
        </template>
      </span>
    <!-- </draggable> -->
    </el-collapse>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import AddEditModal from './AddEditModal.vue'
  import draggable from 'vuedraggable'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      [Input.name]: Input,
      AddEditModal,
      PPagination,
      draggable,
      PSwitch,
      swal
    },
    beforeCreate: function () {
      this.$options.components.LocationGroupSection = require('./LocationGroupSection.vue').default
    },
    created: function () {
      Vue.set(this, 'groupsData', this.groupsDataProp)
      this.getData()
    },
    props: {
      groupsDataProp: {},
      groupToBeDeletedProp: {
        required: false,
        type: Object
      },
      groupToBeAddedProp: {
        required: false,
        type: Object
      },
      groupToBeEditedProp: {
        required: false,
        type: Object
      }
    },
    data () {
      return {
        loading: true,
        groupsData: {},
        activeName: '',
        groupValidations: {
          group_name: {
            required: true
          },
          group_display: {
            required: true
          }
        },
        groupToBeDeleted: null,
        groupToBeEdited: null,
        groupToBeAdded: null
      }
    },
    watch: {
      groupToBeDeletedProp (value) {
        this.deleteLocationsGroup(value)
      },
      groupToBeEditedProp (value) {
        this.editLocationsGroupImageAttribute(value)
      },
      groupToBeAddedProp (value) {
        this.addLocationsGroup(value)
      }
    },
    methods: {
      addLocationsGroup (newGroup) {
        if (newGroup.parent_id === this.groupsData.id &&
          this.groupsData.children &&
          !this.groupsData.children.includes(newGroup)
        ) {
          let newData = []
          newData = [...this.groupsData.children, newGroup]
          Vue.set(this.groupsData, 'children', newData)
        } else {
          Vue.set(this, 'groupToBeAdded', newGroup)
        }
      },
      editLocationsGroupImageAttribute (group) {
        if (this.groupsData.id === group.parent_id) {
          let beforeEditGroup = this.findGroupById(this.groupsData.children, group.id)
          let index = this.groupsData.children.indexOf(beforeEditGroup)
          if (index !== -1) {
            Vue.set(this.groupsData.children[index], 'image', group.image)
          }
        }
      },
      findGroupById (haystack, groupId) {
        let beforeEditGroup = haystack.filter(element => {
          return element.id === groupId
        })
        beforeEditGroup = beforeEditGroup.pop()
        return beforeEditGroup
      },
      deleteLocationsGroup (deletedGroup) {
        if (deletedGroup.parent_id === this.groupsData.id) {
          let filteredData = []
          filteredData = this.groupsData.children.filter(element => {
            return element.id !== deletedGroup.id
          })
          Vue.set(this.groupsData, 'children', filteredData)
        } else {
          Vue.set(this, 'groupToBeDeleted', deletedGroup)
        }
      },
      openEditLocationGroupModal (group) {
        this.$emit('open-modal', group)
      },
      handleActiveGroup (group) {
        let actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${group.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: group.active ? 1 : 0,
              name: group.name,
              id: group.id
            }
            this.apiRequest('/location-groups/' + group.id, 'PUT', data, (response) => {
              if (response.status === true) {
                swal(
                  {
                    title: '',
                    text: this.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {}) // end swal
              } else {
                swal(
                  {
                    title: '',
                    text: this.$t('validations.dataCouldNotBeSaved'),
                    type: 'danger',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {}) // end swal
              }
            })
          }
        }).catch(() => {
          group.active = !group.active
        })
      },
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.groupsData.id
        }

        this.apiRequest('/locations-groups-show-admin', 'GET', data, (response) => {
          if (response.status === true) {
            Vue.set(this.groupsData, 'children', response.data)
            this.$nextTick(function () {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
.pencil-icon {
  padding: 20px 0px 0px;
}

.disable-chck-location-groups{
	padding: 0px;
  position: relative;
  top: 20px;
  padding-top: 10px;
  padding-right: 10px;
  /* position: absolute;
  right: 50px; */
}
.disable-chck-location-groups:first-of-type {
  padding-top: 0px;
} 
.checkbox {
  margin: 0px;
}
.el-collapse-item__wrap {
  width: 100%;
}

i.fa {
  width: 35px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/LocationGroups/LocationGroupSection.vue